import { IconRefresh, IconSearch, IconX, IconCloudUpload, IconTrash, IconDeviceFloppy, IconCamera, IconPhoto } from '@tabler/icons-react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { useEffect, useRef, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../../config/http';
import { CurrencyInput } from '../../utils/CurrencyInput';
import { DinamicTitle } from '../../utils/DinamicTitle';
import CetakStrokePembelian from './CetakStrokePembelian';
import '../../printStrokePembelian.css';
import LayoutsKasir from '../../layouts/LayoutsKasir';
import OpenSearchTrxJTrxB from './DetailScanTrxKasir/OpenSearchTrxJTrxB';
import ConfirmationPembelian from './ConfirmationPembelian';
import imageCompression from 'browser-image-compression';

export default function Pembelian() {
  const [kategori, setKategori] = useState([]);
  const [loading, setLoading] = useState(false);
  const [harga_beli, setHargaBeli] = useState(0);
  const [selectImage, setSelectImage] = useState([]);
  const [formData, setFormData] = useState({
    jenis_kategori_id: '',
    kondisi_barang: '',
    berat: '',
    karat: '',
    surat: '',
    keterangan: '',
  });
  const [kategoriId, setKategoriId] = useState('');
  const [gambar, setGambar] = useState('');

  const [dataPrintPembelian, setDataPrintPembelian] = useState([]);
  // console.log('dataPrintPembelian::: ', dataPrintPembelian);

  const [scanKode, setScanKode] = useState('');
  const [dataScanKode, setDataScanKode] = useState([]);
  // console.log('dataScanKode::: ', dataScanKode);
  const [msg, setMsg] = useState('');

  const { jenis_kategori_id, kondisi_barang, karat, berat, surat, keterangan } = formData;

  const formRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const regex = /^\d*\.?\d{0,3}$/;
    if (formData.berat && !regex.test(formData.berat)) {
      setFormData({
        berat: formData.berat.slice(0, -1),
      });
    }
  }, [formData.berat]);

  function handleOnChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  useEffect(() => {
    async function getKategori() {
      await http
        .get('/kategori', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setKategori(res.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getKategori();
  }, [navigate]);

  function resetForm() {
    setFormData({
      jenis_kategori_id: '',
      kondisi_barang: '',
      berat: '',
      karat: '',
      surat: '',
      keterangan: '',
    });
    setKategoriId('');
    setHargaBeli(0);
    setSelectImage([]);
    setGambar('');
    setJenisKategori([]);
  }

  async function handleSubmitPembelian(e) {
    e.preventDefault();
    const dataPembelian = {
      jenis_kategori_id,
      kondisi_barang,
      karat,
      berat,
      surat,
      harga_beli,
      keterangan,
      gambar,
    };
    // console.log(dataPembelian);
    setLoading(true);
    try {
      setLoading(true);
      const response = await http.post(`pembelian`, dataPembelian, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setDataPrintPembelian(response.data.data);
      resetForm();
      setLoading(false);
      openModal();
      toast.success(response.data.message, { autoClose: 600, });
      return response.data.data;
    } catch (err) {
      if (err.code === 'ERR_NETWORK') {
        toast.warning('Periksa jaringan internet', { autoClose: 600, });
      } else if (err.response.status === 422) {
        toast.warning('Lengkapi input data', { autoClose: 600, });
      } else if (err.response.status === 401) {
        navigate('/login');
      } else if (err.response.status === 500) {
        toast.warning('Terjadi kesalahan di server', { autoClose: 600, });
      }
    }
    setLoading(false);
  }
  DinamicTitle('Kasir Pembelian || Komaladewi');
  const [loadingGetDetailScan, setLoadingGetDetailScan] = useState(false);
  const [statusKode, setStatusKode] = useState('');

  async function handleScanSurat() {
    setLoadingGetDetailScan(true);
    await http
      .get(`penjualan/scan/${scanKode}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDataScanKode(res.data.data);
        setMsg(res.data.message);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          setMsg(err.response.data.message);
          setStatusKode(err.response.status);
        }
      });
    setLoadingGetDetailScan(false);
  }

  const [jenisKategori, setJenisKategori] = useState([]);
  const [req, setReq] = useState({
    KategoriName: '',
    jenis_kategori_id: '',
  });

  async function SelectJenisKategori(idData) {
    setKategoriId(idData);
    await http
      .get(`/jenis/kategori/${idData}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setJenisKategori(res.data.data);
      })
      .catch((err) => {
        console.log('error jenis kategori', err);
      });
  }

  const kondisiOption = [
    { label: 'Service', value: 'Service' },
    { label: 'Ready Jual', value: 'Ready Jual' },
    { label: 'Rongsok', value: 'Rongsok' },
  ];

  const suratOption = [
    { label: 'Ya', value: '1' },
    { label: 'Tidak', value: '0' },
  ];

  const karatOption = [
    { karat: 16 },
    { karat: 17 },
    { karat: 18 },
    { karat: 19 },
    { karat: 20 },
    { karat: 21 },
    { karat: 22 },
    { karat: 23 },
    { karat: 24 },
  ];

  const isFormValid = useMemo(() => {
    return (
      kategoriId !== '' &&
      jenis_kategori_id !== '' &&
      kondisi_barang !== '' &&
      berat !== '' &&
      karat !== '' &&
      surat !== '' &&
      Number(harga_beli) > 0 &&
      selectImage.length > 0
    );
  }, [kategoriId, jenis_kategori_id, kondisi_barang, berat, karat, surat, harga_beli, selectImage]);

  useEffect(() => {
    if (scanKode === '' && scanKode.length < 10) {
      console.log('Silahkan Masukkan Kode untuk mencari barang');
    } else {
      handleScanSurat();
    }
  }, [scanKode, navigate, statusKode]);

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const handleImageChange = async (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);

    if (selectImage.length < 1) {
      const file = selectedFiles[0];

      // Log size before compression
      console.log('Ukuran file sebelum kompresi:', (file.size / 1024).toFixed(2), 'KB');

      // Options for image compression
      const options = {
        maxSizeMB: 1, // Maximum size in MB
        maxWidthOrHeight: 1024, // Maximum width or height
        useWebWorker: true, // Use web worker for better performance
      };

      try {
        // Compress the image
        const compressedFile = await imageCompression(file, options);

        // Log size after compression
        console.log('Ukuran file setelah kompresi:', (compressedFile.size / 1024).toFixed(2), 'KB');

        // Read the compressed image
        const reader1 = new FileReader();
        reader1.addEventListener('load', function () {
          setGambar(reader1.result.split(',')[1]);
        });
        reader1.readAsDataURL(compressedFile);

        // Update the selected image array with the compressed image
        const compressedImageURL = URL.createObjectURL(compressedFile);
        setSelectImage([compressedImageURL]);
      } catch (error) {
        console.error('Error compressing image:', error);
      }
    } else {
      // If more than one image is selected, handle accordingly
      const imagesArray = selectedFilesArray.map((file) => {
        return URL.createObjectURL(file);
      });
      setSelectImage(imagesArray);
    }

    // FOR BUG IN CHROME
    event.target.value = '';
  };

  // const handleImageChange = (event) => {
  //   const selectedFiles = event.target.files;
  //   const selectedFilesArray = Array.from(selectedFiles);

  //   if (selectImage.length < 1) {
  //     const reader1 = new FileReader();
  //     reader1.addEventListener('load', function () {
  //       setGambar(reader1.result.split(',')[1]);
  //     });
  //     reader1.readAsDataURL(selectedFiles[0]);
  //   }
  //   const imagesArray = selectedFilesArray.map((file) => {
  //     return URL.createObjectURL(file);
  //   });
  //   // setSelectImage((previousImages) => previousImages.concat(imagesArray));
  //   setSelectImage(imagesArray);
  //   // FOR BUG IN CHROME
  //   event.target.value = '';
  // };

  let [isOpenModalSearch, setIsOpenModalSearch] = useState(false);

  function closeModalSearch() {
    setIsOpenModalSearch(false);
    setScanKode('');
  }

  function openModalSearch() {
    setIsOpenModalSearch(true);
  }

  let [isOpenConfPembelian, setIsOpenConfPembelian] = useState(false);

  function closeModalConfPembelian() {
    setIsOpenConfPembelian(false);
  }

  function openModalConfPembelian() {
    setIsOpenConfPembelian(true);
  }

  return (
    <LayoutsKasir>
      <div className="mx-auto max-w-4xl">
        <ConfirmationPembelian
          isOpenConfPembelian={isOpenConfPembelian}
          closeModalConfPembelian={closeModalConfPembelian}
          handleSubmitPembelian={handleSubmitPembelian}
          loading={loading}
          formData={formData}
          harga_beli={harga_beli}
          selectImage={selectImage}
        />
        <OpenSearchTrxJTrxB
          setScanKode={setScanKode}
          isOpenModalSearch={isOpenModalSearch}
          closeModalSearch={closeModalSearch}
          scanKode={scanKode}
          dataScanKode={dataScanKode}
          loadingGetDetailScan={loadingGetDetailScan}
          statusKode={statusKode}
          msg={msg}
          numberWithCommas={numberWithCommas}
        />
        <CetakStrokePembelian dataPrintPembelian={dataPrintPembelian} isOpen={isOpen} closeModal={closeModal} />
        {loading ? (
          <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
            <div className="w-12 h-12  rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
          </div>
        ) : (
          ''
        )}
        <div className="bg-white sm:shadow-sm sm:border border-slate-200 sm:rounded-xl">
          {/* Header */}
          <div className="px-4 py-4 sm:px-6 border-b border-slate-200">
            <div className="flex items-start justify-between gap-3">
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Transaksi Pembelian</h1>
                <p className="text-sm text-slate-500 mt-1">
                  Catat transaksi pembelian barang
                </p>
              </div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={openModalSearch}
                  className="h-11 w-11 sm:h-10 sm:w-auto sm:px-4 flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-600 active:bg-amber-700 text-white rounded-xl sm:rounded-lg text-sm font-semibold transition"
                  title="Cari Transaksi"
                >
                  <IconSearch className="w-5 h-5 sm:w-4 sm:h-4" />
                  <span className="hidden sm:inline">Cari</span>
                </button>
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="h-11 w-11 sm:h-10 sm:w-auto sm:px-4 flex items-center justify-center gap-2 bg-slate-100 hover:bg-slate-200 active:bg-slate-300 text-slate-700 rounded-xl sm:rounded-lg text-sm font-semibold transition"
                  title="Refresh halaman"
                >
                  <IconRefresh className="w-5 h-5 sm:w-4 sm:h-4" />
                  <span className="hidden sm:inline">Refresh</span>
                </button>
              </div>
            </div>
          </div>

          <div className="px-4 py-5 sm:p-6 pb-36 sm:pb-6">
            <form ref={formRef} className="space-y-6">

              {/* === Section: Kategori === */}
              <div className="space-y-5">
                <div className="relative">
                  <select
                    value={kategoriId}
                    onChange={(e) => { if (e.target.value) SelectJenisKategori(e.target.value); else { setKategoriId(''); setJenisKategori([]); setFormData({ ...formData, jenis_kategori_id: '' }); } }}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 bg-white px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih Kategori</option>
                    {kategori.map((item) => (
                      <option key={item.id} value={item.id}>{item.nama_kategori}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-500">Kategori</label>
                </div>

                <div className="relative">
                  <select
                    value={formData.jenis_kategori_id}
                    onChange={(e) => setFormData({ ...formData, jenis_kategori_id: e.target.value })}
                    required
                    disabled={!kategoriId}
                    className="w-full h-14 sm:h-12 border border-slate-300 bg-white px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih Jenis Kategori</option>
                    {jenisKategori.map((item) => (
                      <option key={item.id} value={item.id}>{item.nama_jenis}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-500">Jenis Kategori</label>
                </div>
              </div>

              {/* === Section: Kondisi & Surat === */}
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <select
                    value={formData.kondisi_barang}
                    onChange={(e) => setFormData({ ...formData, kondisi_barang: e.target.value })}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 bg-white px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih</option>
                    {kondisiOption.map((item) => (
                      <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-500">Kondisi</label>
                </div>
                <div className="relative">
                  <select
                    value={formData.surat}
                    onChange={(e) => setFormData({ ...formData, surat: e.target.value })}
                    className="w-full h-14 sm:h-12 border border-slate-300 bg-white px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih</option>
                    {suratOption.map((item) => (
                      <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-500">Surat</label>
                </div>
              </div>

              {/* === Section: Berat & Karat === */}
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <input
                    placeholder='Contoh: 2.350'
                    type="number"
                    step="0.001"
                    inputMode="decimal"
                    id="berat"
                    name="berat"
                    required
                    autoComplete="off"
                    value={formData.berat}
                    onChange={handleOnChange}
                    className="w-full h-14 sm:h-12 border border-slate-300 bg-white px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                  />
                  <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-500">Berat (gram)</label>
                </div>
                <div className="relative">
                  <select
                    value={formData.karat}
                    onChange={(e) => setFormData({ ...formData, karat: Number(e.target.value) })}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 bg-white px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih</option>
                    {karatOption.map((item) => (
                      <option key={item.karat} value={item.karat}>{item.karat}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-500">Karat</label>
                </div>
              </div>

              {/* === Section: Harga === */}
              <div className="relative">
                <CurrencyInput
                  name="harga_beli"
                  value={harga_beli}
                  autoComplete="off"
                  onChange={(value) => setHargaBeli(() => value)}
                  className="w-full h-14 sm:h-12 border border-slate-300 bg-white px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                />
                <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-500">Total Harga Beli</label>
              </div>

              {/* === Section: Keterangan === */}
              <div className="relative">
                <textarea
                  id="message"
                  value={formData.keterangan}
                  onChange={handleOnChange}
                  rows={3}
                  name="keterangan"
                  className="w-full border border-slate-300 bg-white px-4 pt-4 pb-2 sm:pt-3.5 sm:pb-2.5 text-base sm:text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                  placeholder="Catatan tambahan (bila ada)..."
                />
                <label className="absolute -top-2.5 left-3 bg-white px-1.5 text-xs font-medium text-slate-500">Keterangan (Opsional)</label>
              </div>

              {/* === Section: Foto === */}
              <div className="bg-slate-50 border border-slate-200 p-4 sm:p-5 rounded-lg">
                <p className="text-sm font-semibold text-slate-700">Foto Barang & Surat</p>
                {/* <p className="text-xs text-slate-400 mt-0.5">Format: JPG/PNG/WEBP</p> */}

                {selectImage.length > 0 && (
                  <div className="mt-4 flex items-center gap-3 overflow-x-auto pb-2">
                    {selectImage.map((image, index) => (
                      <div key={index} className="relative flex-shrink-0">
                        <button
                          type="button"
                          onClick={() => setSelectImage(selectImage.filter((e) => e !== image))}
                          className="absolute -top-2 -right-2 bg-white border border-slate-200 rounded-full p-1.5 shadow-md z-10 active:scale-90 transition-transform"
                        >
                          <IconX width={16} />
                        </button>
                        <PhotoProvider>
                          <PhotoView src={image}>
                            <img
                              className="h-24 w-24 sm:h-20 sm:w-20 rounded-lg border border-slate-200 object-cover bg-white cursor-pointer"
                              src={image}
                              alt="Preview"
                              title="Klik untuk memperbesar gambar"
                            />
                          </PhotoView>
                        </PhotoProvider>
                      </div>
                    ))}
                  </div>
                )}

                <div className="mt-4 grid grid-cols-2 gap-3">
                  <label className="flex items-center justify-center gap-2 h-14 sm:h-11 bg-amber-50 text-amber-700 border-2 border-amber-200 hover:bg-amber-100 active:bg-amber-200 text-sm font-semibold cursor-pointer transition rounded-lg">
                    <IconCamera className="w-5 h-5" />
                    Kamera
                    <input
                      type="file"
                      onChange={handleImageChange}
                      accept="image/*"
                      capture="environment"
                      className="hidden"
                    />
                  </label>
                  <label className="flex items-center justify-center gap-2 h-14 sm:h-11 bg-white text-slate-700 border-2 border-slate-200 hover:bg-slate-50 active:bg-slate-100 text-sm font-semibold cursor-pointer transition rounded-lg">
                    <IconPhoto className="w-5 h-5" />
                    Galeri
                    <input
                      type="file"
                      onChange={handleImageChange}
                      accept="image/png,image/jpeg,image/webp"
                      className="hidden"
                    />
                  </label>
                </div>
              </div>

              {/* === Fixed Bottom Bar === */}
              <div className="fixed sm:static bottom-0 left-0 right-0 p-4 sm:p-0 bg-white sm:bg-transparent border-t sm:border-t-0 border-slate-200 sm:border-transparent shadow-[0_-4px_12px_rgba(0,0,0,0.08)] sm:shadow-none z-40 sm:z-auto">
                <div className="flex gap-3 sm:justify-end">
                  <button
                    type="button"
                    onClick={resetForm}
                    disabled={loading}
                    className="flex-1 sm:flex-none sm:w-auto h-14 sm:h-11 px-5 text-base sm:text-sm font-semibold bg-slate-100 hover:bg-slate-200 active:bg-slate-300 text-slate-700 rounded-xl sm:rounded-lg disabled:opacity-60 transition-colors flex items-center justify-center gap-2"
                  >
                    <IconTrash className="w-5 h-5" />
                    Kosongkan
                  </button>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      openModalConfPembelian();
                    }}
                    disabled={loading || !isFormValid}
                    className="flex-[2] sm:flex-none sm:w-auto h-14 sm:h-11 px-6 text-base sm:text-sm font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 active:from-amber-600 active:to-amber-700 rounded-xl sm:rounded-lg shadow-lg shadow-amber-500/20 disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed disabled:shadow-none transition-all flex items-center justify-center gap-2"
                  >
                    <IconDeviceFloppy className="w-5 h-5" />
                    {loading ? 'Proses...' : 'Simpan'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </LayoutsKasir>
  );
}
